import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import Attribute from 'marketing/common/attribute';
import { trackClickWithMixpanel } from 'common/tracking';
import partial from 'lodash/partial';

const Cta = ({
  title, subtitle, cta, blockClasses, image, post_cta_html, eventTracking=null
}) => {
  const classes = image ? 'small-16 large-10' : 'small-16';

  return (
    <section className={classnames('block block-cta', { 'with-image': !!image }, blockClasses)}>
      <div className="row">
        <div className={classnames('columns', classes)}>
          <div className="block-header">
            <h2 dangerouslySetInnerHTML={{ __html: title }} />
            {subtitle &&
              <h4>{subtitle}</h4>
            }
          </div>

          { cta.anchor?
            <a href={cta.anchor} className="btn btn-primary">{cta.label}</a>:
            <Link to={cta.url} rel="nofollow" className="btn btn-primary">
            <span onClick={eventTracking ? partial(trackClickWithMixpanel, eventTracking.eventName, eventTracking.eventData) : () => {} }>{cta.label}
              </span>
            </Link>
          }

          {post_cta_html &&
          <p dangerouslySetInnerHTML={{ __html: post_cta_html }} />
         }
        </div>
        {image &&
          <div className="small-16 large-6 columns">
            <div className="image-container relative">
              <img
                src={image.url}
                alt={image.alt}
                className={classnames('cta-image', image.imageClass)}
              />
              {image.attribution &&
              <Attribute to={image.attribution} />
            }
            </div>
          </div>
        }
        { image && <div className="image-background"/> }
      </div>
    </section>
  );
};

Cta.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  cta: PropTypes.object,
  blockClasses: PropTypes.string,
  image: PropTypes.object,
  post_cta_html: PropTypes.string
};

export default Cta;



// WEBPACK FOOTER //
// ./marketing/common/cta.jsx